module.exports = "<span class=\"font-roboto-bold font-size-20\" mat-dialog-title>\n  {{ data.title }}\n</span>\n<mat-dialog-content>\n  <mat-form-field class=\"full-width\">\n    <input matInput [placeholder]=\"data.placeholder\" [(ngModel)]=\"value\">\n  </mat-form-field>\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-button (click)=\"save()\" tabindex=\"2\" [disabled]=\"!value\">Guardar</button>\n  <button mat-button (click)=\"close()\" tabindex=\"-1\">Cancelar</button>\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/input-text/input-text.component.html
// module id = ./src/app/components/input-text/input-text.component.html
// module chunks = main